import { siteData } from "../data/mock";
import { Check, ExternalLink, MessageCircle } from "lucide-react";

export const InvisalignSection = () => {
  return (
    <section
      id="invisalign"
      className="py-20 relative overflow-hidden text-white"
      style={{ background: 'linear-gradient(135deg, #1F1F1F 0%, #2a3040 50%, #1F1F1F 100%)' }}
    >
      {/* Decorative glow */}
      <div className="absolute top-0 right-0 w-80 h-80 rounded-full opacity-15" style={{ backgroundColor: '#85BCFF', filter: 'blur(100px)' }} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          {/* Content */}
          <div>
            <span className="text-sm font-semibold uppercase tracking-wider mb-3 block" style={{ color: '#85BCFF' }}>
              Destaque
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 leading-tight">
              {siteData.invisalign.title}
            </h2>
            <p className="text-lg mb-2 font-medium" style={{ color: '#85BCFF' }}>
              {siteData.invisalign.subtitle}
            </p>
            <p className="text-base mb-8 leading-relaxed text-slate-300">
              {siteData.invisalign.description}
            </p>

            {/* Benefits */}
            <ul className="space-y-3 mb-8">
              {siteData.invisalign.benefits.map((benefit, idx) => (
                <li key={idx} className="flex items-center gap-3">
                  <div
                    className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{ backgroundColor: 'rgba(133, 188, 255, 0.2)' }}
                  >
                    <Check size={14} style={{ color: '#85BCFF' }} />
                  </div>
                  <span className="text-sm text-slate-200">{benefit}</span>
                </li>
              ))}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={siteData.brand.invisalignLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-lg text-base font-bold transition-all duration-200 hover:scale-105 hover:shadow-xl"
                style={{ backgroundColor: '#85BCFF', color: '#1F1F1F' }}
              >
                {siteData.invisalign.ctaText}
                <ExternalLink size={16} />
              </a>
              <a
                href={siteData.brand.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-lg text-base font-semibold border-2 transition-all duration-200 hover:bg-white/10"
                style={{ borderColor: 'rgba(133, 188, 255, 0.4)', color: '#85BCFF' }}
              >
                <MessageCircle size={16} />
                Agendar Consulta
              </a>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={siteData.images.consultorio}
                alt="Consultório - Dra. Giovana Gamborgi"
                className="w-full h-[480px] lg:h-[560px] object-cover"
              />
            </div>
            {/* Badge */}
            <div className="absolute -bottom-4 left-4 sm:left-8 bg-white rounded-xl shadow-xl p-4 border-2" style={{ borderColor: '#85BCFF' }}>
              <p className="text-xs uppercase tracking-wider font-bold mb-0.5" style={{ color: '#85BCFF' }}>
                Invisalign Top Doctor
              </p>
              <p className="text-sm font-semibold text-slate-900">
                Dra. Giovana Gamborgi
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
